import React from 'react'
import Row from './Row'

export default function Rows (props) {
  return (
    <div className='data-table__rows'>
      {props.rows.length > 0 && props.rows.map((row, i) => {
        return <Row {...row} key={i} />
      })}
    </div>
  )
}
